import React from "react"
import { PaperclipIcon } from "components/page-components/Icons/small"
import parseHtml from "scripts/parseHtml"

export const MessagePreview = ({
  attachments,
  body,
  index,
  num_messages,
  releaseDate,
  set_message_modal_state,
  subject,
}) => {
  const parsed_body = parseHtml(body)

  const open_message_modal = () => {
    set_message_modal_state({
      body,
      subject,
      attachments,
      message_modal_open: "is-active",
    })
  }
  return (
    <React.Fragment>
      <div
        className="is-clickable notice-page-message-preview p-5"
        onClick={open_message_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="open Message Modal"
      >
        <div className="columns is-vcentered is-gapless">
          <div className="column">
            <p
              className="has-text-weight-bold has-text-mitternachtsblau"
              style={{
                maxWidth: 700,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {subject}
            </p>
          </div>
          <div className="column is-narrow">
            {!!attachments?.[0] ? <PaperclipIcon {...{ size: 0.9 }} /> : null}
          </div>
          <div className="column is-narrow">
            <p className="title is-7 has-text-mitternachtsblau-30 px-3 ">
              {new Intl.DateTimeFormat("de-DE", {
                timeZone: "Europe/Berlin",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              })
                .format(new Date(releaseDate))
                .replace(/,/i, " -")}
            </p>
          </div>
        </div>

        <div className="has-text-mitternachtsblau notice-message-preview-body pr-2">
          {parsed_body}
        </div>
      </div>
      {index !== num_messages - 1 ? (
        <hr className="is-slim is-mitternachtsblau-10 my-0 mx-5" />
      ) : null}
    </React.Fragment>
  )
}
